import { render, staticRenderFns } from "./clone-order-link.vue?vue&type=template&id=25369dc1"
import script from "./clone-order-link.vue?vue&type=script&lang=js"
export * from "./clone-order-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports